import React, { useState } from 'react'
import {
  Box,
  Tabs,
  Tab,
  Alert
} from '@mui/material'
import {
  Assessment as AssessmentIcon,
  TrendingUp as TrendingUpIcon,
  Dashboard as DashboardIcon,
} from '@mui/icons-material'
import { useAuth } from '../contexts/AuthContext'
import { PageHeader } from '../components/ui'

// Import componentele existente
import ScoringPage from './ScoringPage'
import KPIPage from './KPIPage'
import MedicDashboardPage from './MedicDashboardPage'

const AnalyticsPage: React.FC = () => {
  const { user } = useAuth()
  const [activeTab, setActiveTab] = useState(0)

  // Definim tab-urile - clean și simplu
  const allTabs = [
    {
      label: 'Dashboard Medic',
      icon: <DashboardIcon />,
      roles: ['medic', 'admin', 'operator'],
      component: <MedicDashboardPage />
    },
    {
      label: 'Scoring Medici',
      icon: <AssessmentIcon />,
      roles: ['admin', 'operator'],
      component: <ScoringPage />
    },
    {
      label: 'KPI-uri',
      icon: <TrendingUpIcon />,
      roles: ['admin', 'operator'],
      component: <KPIPage />
    }
  ]

  // Filtrăm tab-urile pe baza rolului utilizatorului
  const availableTabs = allTabs.filter(tab => 
    tab.roles.includes(user?.role || '')
  )

  // Verifică permisiunile
  if (!user || availableTabs.length === 0) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="error">
          Nu aveți permisiuni pentru a accesa această pagină.
        </Alert>
      </Box>
    )
  }

  // Tab-urile ca element pentru PageHeader - Compact
  const tabsElement = (
    <Tabs 
      value={activeTab} 
      onChange={(_, newValue: number) => setActiveTab(newValue)}
      variant="scrollable"
      scrollButtons="auto"
      sx={{
        minHeight: 36,
        '& .MuiTab-root': {
          minHeight: 36,
          fontSize: '0.78rem',
          py: 0.5,
          px: 1.5,
          textTransform: 'none',
          '& .MuiSvgIcon-root': { fontSize: 16, mr: 0.5 }
        }
      }}
    >
      {availableTabs.map((tab, index) => (
        <Tab
          key={index}
          icon={tab.icon}
          iconPosition="start"
          label={tab.label}
        />
      ))}
    </Tabs>
  )

  return (
    <Box>
      {/* Unified Page Header cu titlu și tab-uri */}
      <PageHeader
        title="Analytics & Raportare"
        tabs={tabsElement}
      />

      {/* Content pentru tab-ul activ */}
      {availableTabs[activeTab]?.component}
    </Box>
  )
}

export default AnalyticsPage
